import React from 'react';
import { Icon } from './Icon';

interface XIconProps {
  size?: number | string;
  className?: string;
  color?: string;
}

export const XIcon: React.FC<XIconProps> = ({ size = 16, className, color = '#ef4444' }) => (
  <Icon size={size} className={className} color={color} title="Close">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </Icon>
);

export default XIcon;
